// Base URL of the backend API, injected at build time (set REACT_APP_BACKEND_URL in
// frontend/.env). Empty means same-origin: requests go to /api/... on the page's own host.
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
